export const EvaluationSkillGravity = {
    path: '/evaluation_skill_gravities',
    name: 'evaluation_skill_gravities',
    component: () => import('@/views/Evaluation/Gravity/EvaluationSkillGravityPage.vue'),
    props: {
        type: 'EVALUATION_SKILL',  
    },
    children: [
        {
            path: '/evaluation_skill_gravities/add',
            name: 'evaluation_skill_gravities.add',
            component: () => import('@/views/Evaluation/Gravity/Form/EvaluationGravityForm.vue'),
            props: {
                addAction: true,
                type: 'EVALUATION_SKILL',
            }
        },
        {
            path: '/evaluation_skill_gravities/edit/:id',
            name: 'evaluation_skill_gravities.edit',
            component: () => import('@/views/Evaluation/Gravity/Form/EvaluationGravityForm.vue'),
            props: {
                updateAction: true,
                type: 'EVALUATION_SKILL',
            }
        },
        {
            path: '/evaluation_skill_gravities/delete/:id',
            name: 'evaluation_skill_gravities.delete',
            component: () => import('@/views/Evaluation/Gravity/Form/EvaluationGravityForm.vue'),
            props: {
                deleteAction: true,
                type: 'EVALUATION_SKILL',
            }
        },
        {
            path: '/evaluation_skill_gravities/view/:id',
            name: 'evaluation_skill_gravities.view',
            component: () => import('@/views/Evaluation/Gravity/Form/EvaluationGravityForm.vue'),
            props: {
                viewAction: true,
                type: 'EVALUATION_SKILL',
            }
        },
    ]
}